/**
 * @generated SignedSource<<79399326bee99c89807bb75c872b1185>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EthereumConnectionZipCodeForm_viewer$data = {
  readonly walletConnectFeatureFlag: boolean | null;
  readonly " $fragmentType": "EthereumConnectionZipCodeForm_viewer";
};
export type EthereumConnectionZipCodeForm_viewer$key = {
  readonly " $data"?: EthereumConnectionZipCodeForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"EthereumConnectionZipCodeForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EthereumConnectionZipCodeForm_viewer",
  "selections": [
    {
      "alias": "walletConnectFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "allowWalletConnect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e42fb7691f88892b5fbd46c4578bd36b";

export default node;
